module.exports = __webpack_public_path__ + "img/yeYaBeng3.48398fd2.png";